export function dealScoreColor(score: number | null, threshold: number): string {
  if (score === null) return "bg-zinc-800 text-zinc-500";
  if (score < 0) return "bg-red-700/30 text-red-300";
  if (score >= threshold) return "bg-green-700/30 text-green-300";
  return "bg-yellow-700/30 text-yellow-300";
}

export function dealScoreLabel(score: number | null): string {
  if (score === null) return "—";
  return `${Math.round(score * 100)}%`;
}
